
export const PREVIOUS = 'Previous';
export const NEXT = 'Next';
export const SUBMIT = 'Submit';